import React from 'react';

const TermsAndConditionsEn = () => {
  return (
    <div
      style={{
        padding: '48px',
        lineHeight: '1.6',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <h1>Terms and Conditions for Fotogram Technology</h1>
      <p>
        <strong>Effective Date:</strong> 22.11.2024
      </p>

      <section>
        <h2>1. Preamble</h2>
        <p>
          Welcome to Fotogram Technology! Fotogram Technology offers an
          innovative platform designed for photographers to increase their
          efficiency, strengthen their brand, and provide their clients with a
          unique experience. With features such as CRM tools, calendar
          integration, live photo sharing, AI-powered facial recognition, and
          digital album creation, Fotogram Technology helps photographers
          optimize their workflows and grow their business. By using Fotogram
          Technology, you agree to these Terms and Conditions (T&C).
        </p>
      </section>

      <section>
        <h2>2. Scope</h2>
        <p>
          2.1 These T&C apply to all users of the Fotogram Technology platform,
          regardless of their location.
        </p>
        <p>
          2.2 Any deviating or supplementary terms and conditions proposed by
          users are only valid if explicitly approved in writing by Fotogram
          Technology.
        </p>
        <p>
          2.3 By registering and using the platform, users accept the latest
          version of these T&C.
        </p>
      </section>

      <section>
        <h2>3. Contract Formation and Registration</h2>
        <p>
          3.1 A contractual relationship is established upon successful
          registration and first login by the user.
        </p>
        <p>
          3.2 Fotogram Technology offers a free 30-day trial period. After the
          trial, accounts will automatically be downgraded to the free plan
          unless payment information is provided.
        </p>
        <p>
          3.3 Users can activate paid features at any time by submitting their
          payment details.
        </p>
      </section>

      <section>
        <h2>4. Services Provided by Fotogram Technology</h2>
        <p>
          4.1 Fotogram Technology provides photographers with the following
          features:
        </p>
        <ul>
          <li>
            Storage and Galleries: Store and manage images and create digital
            galleries.
          </li>
          <li>CRM Tools: Manage clients, contracts, and events.</li>
          <li>AI Features: Facial recognition and real-time photo sharing.</li>
          <li>Calendar Integration: Synchronize with business calendars.</li>
          <li>
            Digital Album Creation: Create personalized albums from over 400
            templates.
          </li>
          <li>
            Live Photo Sharing: Share photos during events in real time using QR
            codes.
          </li>
          <li>
            Multilingual Interface: Operate the platform in multiple languages.
          </li>
          <li>
            Digital Shop Integration: Set up a shop for print services or other
            products.
          </li>
        </ul>
        <p>
          4.2 Fotogram Technology reserves the right to expand, limit, or modify
          its services, provided such changes are reasonable for users.
        </p>
      </section>

      <section>
        <h2>5. User Obligations</h2>
        <p>
          5.1 Users must provide complete and accurate information during
          registration and update their details if changes occur.
        </p>
        <p>
          5.2 Users are responsible for maintaining the confidentiality of their
          login credentials and must not share them with third parties.
        </p>
        <p>
          5.3 Users may not misuse the platform, including but not limited to:
        </p>
        <ul>
          <li>Uploading illegal, defamatory, or obscene content.</li>
          <li>
            Violating copyright or third-party intellectual property rights.
          </li>
          <li>Using automated systems to access the platform.</li>
        </ul>
        <p>
          5.4 Users retain ownership of the content they upload but are
          responsible for ensuring their compliance with applicable copyright
          laws.
        </p>
      </section>

      <section>
        <h2>6. Right of Withdrawal for Consumers</h2>
        <p>
          6.1 Consumers have the right to withdraw from the contract within 14
          days without providing a reason.
        </p>
        <p>
          6.2 To exercise this right, users must notify Fotogram Technology in
          writing (e.g., via email).
        </p>
        <p>
          6.3 Details on the withdrawal process are provided in the Withdrawal
          Policy.
        </p>
      </section>

      <section>
        <h2>7. Prices, Taxes, and Fees</h2>
        <p>
          7.1 All prices are exclusive of VAT or other applicable taxes unless
          stated otherwise.
        </p>
        <p>
          7.2 EU-based users are responsible for complying with their country's
          tax regulations (e.g., reverse charge mechanism).
        </p>
        <p>
          7.3 Fotogram Technology reserves the right to adjust prices for paid
          features. Changes will be communicated to users in advance.
        </p>
      </section>

      <section>
        <h2>8. Liability</h2>
        <p>
          8.1 Fotogram Technology is only liable for damages caused by willful
          misconduct or gross negligence.
        </p>
        <p>
          8.2 Liability for indirect damages, data loss, or loss of profit is
          excluded unless caused by gross negligence.
        </p>
        <p>
          8.3 Users are responsible for regularly backing up their content.
          Fotogram Technology is not liable for data loss resulting from user
          errors or unforeseen events.
        </p>
        <p>
          8.4 Fotogram Technology is not liable for service interruptions or
          limitations caused by force majeure or third-party providers.
        </p>
      </section>

      <section>
        <h2>9. Data Protection and Security</h2>
        <p>
          9.1 Fotogram Technology processes personal data in compliance with the
          General Data Protection Regulation (GDPR).
        </p>
        <p>
          9.2 All data is stored exclusively on servers located in Germany.
          Details about data processing can be found in the Privacy Policy.
        </p>
        <p>
          9.3 Users retain ownership of their uploaded content. Fotogram
          Technology is granted a limited license to process and display this
          content on the platform.
        </p>
      </section>

      <section>
        <h2>10. Termination and Contract Duration</h2>
        <p>
          10.1 The contract duration depends on the billing period chosen by the
          user.
        </p>
        <p>
          10.2 Users may terminate the contract at any time at the end of the
          current billing period.
        </p>
        <p>
          10.3 Fotogram Technology reserves the right to terminate the contract
          without notice in cases of T&C violations.
        </p>
      </section>

      <section>
        <h2>11. Final Provisions</h2>
        <p>
          11.1 The laws of the State of Israel apply, unless mandatory legal
          provisions of another country take precedence.
        </p>
        <p>
          11.2 For disputes, the place of jurisdiction is Tel Aviv, Israel,
          where legally permissible.
        </p>
        <p>
          11.3 If any provision of these T&C is found to be invalid, the
          validity of the remaining provisions remains unaffected.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditionsEn;
